import {Fragment} from 'react';
import classes from './ContentHolder.module.css';

const ContentHolder = props =>{
return(
    <Fragment><div className={classes.contentHolder}>{props.children}</div></Fragment>)
}

export default ContentHolder;